import type { RRRouteObject, RouteObject } from "src/router";
import type { SpacesAccess } from "./types";

export interface RouteSpacesAccessHandle {
  spacesAccess: SpacesAccess;
}

/**
 * Attaches spacesAccess to the route's `handle` property.
 *
 * React Router's `handle` is arbitrary route metadata accessible at runtime
 * via useMatches(). SpaceAccessGuard reads this to determine if the current
 * route should be blocked when in a space, without needing to wrap every
 * route element individually.
 */
function addHandle(route: RouteObject): RRRouteObject {
  const { spacesAccess, ...rest } = route;
  if (!rest.index) {
    // If it's a non-index route, there might be children that need to be processed; this is a separate branch to preserve the IndexRouteObject vs NonIndexRouteObject distinction for the tsc
    return {
      ...rest,
      handle: { spacesAccess } satisfies RouteSpacesAccessHandle,
      children: rest.children?.map(addHandle),
    };
  }

  return {
    ...rest,
    handle: { spacesAccess } satisfies RouteSpacesAccessHandle,
  };
}

/**
 * Prepares routes with spaces access metadata by attaching it to route handles.
 */
export function prepareRoutes(routes: RouteObject[]): RRRouteObject[] {
  return routes.map(addHandle);
}
